import React from 'react';
import { string, shape, arrayOf, func } from 'prop-types';
import Icon from 'components/icon';
import GoogleIcon from '../../../google-icon';

export default class KeywordFilter extends React.Component {
    constructor(props) {
        super(props);

        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleKeyPress(e) {
        // Pass the input value back to the update call back function when enter is pressed
        if (e.key === 'Enter') {
            e.preventDefault(); // stops kentico page form from submitting
            this.props.updateKeyword.call(this, e, this.props.filter, e.target.value);
        }
    }

    handleChange(e) {
        this.props.updateKeyword.call(this, e, this.props.filter, e.target.value);
    }

    render() {
        const inputId = `keyword-search-${this.props.filter.code}`;
        return (
            <div className={`keyword-filter form-element ${this.props.classModifier}`}>
                <div className="label-wrapper hidden">
                    <label htmlFor={inputId}>Keyword Search</label>
                </div>
                <div className="input-wrapper">
                    <input type="text" maxLength="250" id={inputId} value={this.props.keyword} onChange={this.handleChange} onKeyPress={this.handleKeyPress} placeholder={this.props.placeholderText} />
                </div>
                <Icon glyph="search" />
                <GoogleIcon icon="search" />
            </div>
        );
    }
}

KeywordFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    keyword: string,
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(string)
    }).isRequired,
    placeholderText: string,
    updateKeyword: func.isRequired,
    classModifier: string
    /* eslint-enable react/no-typos */
};

KeywordFilter.defaultProps = {
    keyword: '',
    placeholderText: '',
    classModifier: ''
};
